<template>
  <div
    class="d-flex align-items-center justify-content-center match-wrapper-duel--details"
    :data-round-index="roundIndex"
    :data-match-index="matchIndex"
  >
    <Panel
      class="match-card my-0 px-4 py-3 cursor-pointer active p-4"
      :variant="[
        'default',
        'stroked',
        isActive ? 'stroked-accent' : 'stroked-secondary',
        'rounded',
        'rounded-medium',
      ]"
      :class="{
        empty: !match.id,
      }"
      v-on="$listeners"
    >
      <Panel
        :key="`${match.id}-info`"
        :variant="['transparent']"
        class="p-0 mb-0 match-bottom-addons d-flex align-items-center justify-content-between"
      >
        <TextBlock
          v-if="match.battle_id"
          class="p-0 mt-0 battle-id-label"
          variant="secondary"
          :size="0.75"
        >
          {{
            $t('_web_tournament_battle_id', '# {match}', {
              match: match.index + 1,
            })
          }}<span class="mx-3">|</span>{{ roundName }}
        </TextBlock>
        <StatusLabel
          :status="match.status"
          class="px-4 py-3 position-absolute match-status"
        />
        <Icon
          name="calendar"
          width="20"
          :fill="$scss.colors.secondaryTextBg"
          class="h-ml-auto h-mr-3"
        />
        <TextBlock :size="0.75" :variant="'secondary'" :line-height="1"
          >{{ match.date_start | localDate($times.DATE_SUBMED) }},</TextBlock
        >
        <TextBlock
          class="h-ml-3"
          :size="0.75"
          :variant="'secondary'"
          :line-height="1"
          >{{ match.date_start | localDate($times.TIME_SIMPLE) }}</TextBlock
        >
      </Panel>
      <div
        class="d-flex mt-4"
        :class="{
          'align-items-center justify-content-between': vsMode,
          'flex-column align-items-start justify-content-start': !vsMode,
        }"
      >
        <div
          :class="{
            'player-wrapper--vs-mode flex-grow-0 flex-shrink-0  align-self-start': vsMode,
            'w-100 mb-4': !vsMode,
          }"
        >
          <PlayerItem
            class="p-0"
            :class="{
              'flex-grow-0 flex-column align-items-center justify-content-center': vsMode,
              'flex-grow-1': !vsMode,
            }"
            :player="match.player_1"
            :hide-score="vsMode"
            hide-checkin
            :avatar-size="48"
            :player-score="playerOneScore"
            :round-index="roundIndex"
            :match-index="matchIndex"
            :player-index="1"
            :variant="playerOneVariant"
            :is-profile="isSingle"
            :chat-with="match.captain_1"
            :is-ready-for-battle="!match.is_detained || match.player_1_ready"
            :is-empty="match.player_empty_1"
            v-on="{
              userMenuOpen: $listeners.userMenuOpen || $lodash.noop,
            }"
          />
        </div>
        <Scores
          v-if="vsMode"
          :value="summaryScores"
          class="flex-shrink-0 flex-nowrap mb-5"
        />
        <div
          :class="{
            'player-wrapper--vs-mode flex-grow-0 flex-shrink-0  align-self-start': vsMode,
            'w-100 mb-4': !vsMode,
          }"
        >
          <PlayerItem
            class="p-0"
            :class="{
              'flex-grow-0 flex-column align-items-center justify-content-center': vsMode,
              'flex-grow-1': !vsMode,
            }"
            :player="match.player_2"
            :hide-score="vsMode"
            hide-checkin
            :avatar-size="48"
            :player-score="playerTwoScore"
            :round-index="roundIndex"
            :match-index="matchIndex"
            :player-index="2"
            :variant="playerTwoVariant"
            :is-profile="isSingle"
            :chat-with="match.captain_2"
            :is-ready-for-battle="!match.is_detained || match.player_2_ready"
            :is-empty="match.player_empty_2"
            v-on="{
              userMenuOpen: $listeners.userMenuOpen || $lodash.noop,
            }"
          />
        </div>
      </div>
    </Panel>
  </div>
</template>

<script>
import Panel from '@/components/atoms/Panel';
import { BATTLE_STATUSES } from '@/constants/battles';
import { getPlayerScore } from '@/views/tournaments/utils/players';
import PlayerItem from '@/components/tournaments/playerItem.vue';
import { prop, propRequired } from '@/utils/factories';
import StatusLabel from '@/components/molecules/StatusLabel';
import TextBlock from '@/components/atoms/TextBlock';
// import TextLabel from '@/components/atoms/TextLabel';
import Icon from '@/components/atoms/Icon';
import Scores from '@/components/tournaments/Scores.vue';
export default {
  name: 'DuelMatchCardDetails',
  components: {
    Panel,
    PlayerItem,
    StatusLabel,
    TextBlock,
    Icon,
    // TextLabel,
    Scores,
  },
  props: {
    isSingle: prop(Boolean),
    isActive: prop(Boolean),
    vsMode: prop(Boolean),
    roundIndex: propRequired(Number),
    roundName: prop(String),
    matchIndex: propRequired(Number),
    match: {
      type: Object,
      default: () => ({
        date_end: null,
        date_start: null,
        id: '',
        index: 0,
        next_match_id: '',
        next_match_index: 0,
        player_1: {},
        player_1_score: null,
        player_2: {},
        player_2_score: null,
        round: 0,
        isLoading: false,
      }),
    },
  },
  computed: {
    matchID() {
      return this.match.id;
    },
    summaryScores() {
      return {
        player_1_scored: this.playerOneScore,
        player_2_scored: this.playerTwoScore,
      };
    },
    playerOneScore() {
      return getPlayerScore(this.match, 1);
    },

    playerTwoScore() {
      return getPlayerScore(this.match, 2);
    },
    isMatchCancelled() {
      return this.match.status === BATTLE_STATUSES.cancelled;
    },
    playerOneVariant() {
      return this.match.is_detained && !this.match.player_1_ready
        ? 'error'
        : 'transparent';
    },

    playerTwoVariant() {
      return this.match.is_detained && !this.match.player_2_ready
        ? 'error'
        : 'transparent';
    },
    isScheduled() {
      return this.match.status === 'scheduled';
    },
  },
};
</script>

<style lang="scss">
.match-wrapper-duel--details {
  min-height: $match-item-height;
  max-width: 450px;
  transition: all 0.2s ease-in;
  .match-card {
    z-index: 1;
    width: 450px;
    &_duel-score {
      min-width: 108px;
      flex-basis: 108px;
      height: 40px;
    }
    .player-wrapper--vs-mode {
      flex-basis: calc(50% - 54px);
      max-width: calc(50% - 54px);
    }
    .battle-id-label {
      @include auto-rtl(left, 0);
    }
    .match-status {
      @include auto-rtl(left, 50%);
      @include auto-rtl(transform, translateX(-50%));
    }
  }
}
</style>
